import {CF_API} from '@/config';

let _token: string | undefined;

export function setMediaToken(token: string): void {
  _token = token;
}

export function mediaUrl(path: string | null | undefined): string | undefined {
  if (!path) return undefined;
  const url = `${CF_API}data/${path}`;
  return _token ? `${url}?token=${_token}` : url;
}
